import { InjectionToken } from '@angular/core';
import { CameraService } from './camera.service';

export const SOFTLINE_CONFIG_CAMERA = new InjectionToken<CameraService[]>(
  'SOFTLINE_CONFIG_CAMERA'
);
export const SOFTLINE_CONFIG_CAMERA_SELECTOR = new InjectionToken<
  (services: CameraService[]) => CameraService
>('SOFTLINE_CONFIG_CAMERA_SELECTOR');
